import * as React from "react";
import PropTypes from "prop-types";
import { Grid, TextField } from "@material-ui/core";
import { StyledDarkBackground } from "../../theme/Form";
import inputValidation from "../../util/inputValidation";

export default function AddressForm({ address, setAddress }) {
  return (
    <StyledDarkBackground>
      <Grid item container spacing={2}>
        <Grid item xs={6}>
          <TextField
            variant="outlined"
            label="First Name"
            size="small"
            inputProps={inputValidation.firstName}
            value={address.firstName}
            onChange={setAddress("firstName")}
            required
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            variant="outlined"
            label="Last Name"
            size="small"
            inputProps={inputValidation.lastName}
            value={address.lastName}
            onChange={setAddress("lastName")}
            required
            fullWidth
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            variant="outlined"
            label="Address"
            size="small"
            inputProps={inputValidation.address}
            value={address.address}
            onChange={setAddress("address")}
            required
            fullWidth
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            variant="outlined"
            label="Apartment, suite, etc (optional)"
            size="small"
            inputProps={inputValidation.address2}
            value={address.address2}
            onChange={setAddress("address2")}
            fullWidth
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            variant="outlined"
            label="City"
            size="small"
            inputProps={inputValidation.city}
            value={address.city}
            onChange={setAddress("city")}
            required
            fullWidth
          />
        </Grid>

        <Grid item xs={4}>
          <TextField
            variant="outlined"
            label="Country"
            size="small"
            inputProps={inputValidation.country}
            value={address.country}
            onChange={setAddress("country")}
            required
            fullWidth
          />
        </Grid>

        <Grid item xs={4}>
          <TextField
            variant="outlined"
            label="State"
            size="small"
            inputProps={inputValidation.state}
            value={address.state}
            onChange={setAddress("state")}
            required
            fullWidth
          />
        </Grid>

        <Grid item xs={4}>
          <TextField
            variant="outlined"
            label="Zip Code"
            size="small"
            inputProps={inputValidation.zipCode}
            value={address.zipCode}
            onChange={setAddress("zipCode")}
            required
            fullWidth
          />
        </Grid>
      </Grid>
    </StyledDarkBackground>
  );
}

AddressForm.propTypes = {
  address: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    address: PropTypes.string,
    address2: PropTypes.string,
    city: PropTypes.string,
    country: PropTypes.string,
    state: PropTypes.string,
    zipCode: PropTypes.string,
  }),
};
